module.exports = __webpack_public_path__ + "static/media/linkedInNew.fccabb4b.png";